import React from 'react';
import Header from '../components/Header';
import { database } from '../config';
import ReactTable from "react-table";
import "react-table/react-table.css";
const COLUMNS =
[
  { Header: 'Num', accessor: 'num' },
  { Header: 'Question', accessor: 'question' },
  { Header: 'Option1' , accessor: 'option1' },
  { Header: 'Option2' , accessor: 'option2' },
  { Header: 'Option3' , accessor: 'option3' },
];
const DATA1 = 
[
    {
        num : "1",
        question: "איזו דרגה קצין טרי בצהל יקבל?",
        option1: "סגן",
        option2 : "סגם",
        option3 : "סרן"
    },
    {
        num : "2",
        question: "מי כיהן כנשיא ארה''ב לפני דונאלד טראמפ",
        option1: "גורג בוש",
        option2 : "ביל קלינטון",
        option3 : "ברק אובמה"
    },
    {
        num : "3",
        question: "באיזו שנה התרחש פיגוע התאומים?",
        option1: "2001",
        option2 : "2000",
        option3 : "2003"
    },
];
class Questions extends React.Component {
    constructor() {
        super();
        this.state = {
            data : [],
            general : []
        }
        

    }

    componentDidMount() {
        database.ref('/General').on('value', (general) => {
            this.setState({ general: general.val() });
            database.ref('/Questions/' + general.val().currentGame + '/1518691470465/').on('value', (questions) => {
              this.setState({ data: questions.val() });
            });
          });
    }





    render() {
        return (
            <div>
                <Header pageTitle='Questions' />
                <h1>Questions</h1>
                <ReactTable
                    data={DATA1}
                    columns={COLUMNS}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
            </div>

        );
    }
}

export default Questions;


// WEBPACK FOOTER //
// ./src/containers/Questions.js